import axios from 'axios';
import { updateCartUI } from './ui.js';

/**
 * Mensaje de error a mostrar: se prefiere el del servidor (validación o regla de
 * negocio) sobre un texto genérico.
 */
export function mensajeDeError(error, porDefecto) {
    const data = error?.response?.data;

    if (data?.message && !data?.errors) {
        return data.message;
    }

    if (data?.errors) {
        return Object.values(data.errors).flat()[0];
    }

    return porDefecto;
}

class Cart {
    updateCart(itemId, quantity) {
        updateCartUI.toggleButtons(true);
        axios.post(route('clientUpdateCart'), {
            item_id: itemId,
            quantity: quantity
        })
        .then(response => {
            const data = response.data;
            if(data.status){
                updateCartUI.updateCartItem(data.item);
                updateCartUI.refreshState();
            }else{
                updateCartUI.showToast(data.message, '#dc3545');
            }
        })
        .catch(error => {
            console.error('Error al actualizar el carrito:', error);
            updateCartUI.showToast(mensajeDeError(error, 'No se pudo actualizar el carrito'), '#dc3545');
        }).then(function(){
            updateCartUI.toggleButtons(false);
        });
    }

    /**
     * Guarda la nota de una línea del carrito (vacía = sin nota). Devuelve si se
     * guardó, para que el modal sepa si cerrarse.
     */
    updateNota(itemId, nota) {
        return axios.post(route('clientCartNota'), {
            item_id: itemId,
            nota: nota
        })
        .then(response => {
            const data = response.data;
            if(data.status){
                updateCartUI.setNota(itemId, data.nota);
                updateCartUI.showToast(data.message);
                return true;
            }
            updateCartUI.showToast(data.message, '#dc3545');
            return false;
        })
        .catch(error => {
            console.error('Error al guardar la nota:', error);
            updateCartUI.showToast(mensajeDeError(error, 'No se pudo guardar la nota'), '#dc3545');
            return false;
        });
    }

    addProductToCart(productId, quantity, on, adicionales = []) {
        updateCartUI.toggleButtons(true);
        axios.post(route('clientAddToCart'), {
            product_id: productId,
            quantity: quantity,
            on: on,
            adicionales: adicionales,
        })
        .then(response => {
            var data = response.data
            if(data.status){
                updateCartUI.addItemHash(productId, data.hash);
                updateCartUI.updateCartCount(data.cart.items_count);
                // El servidor devuelve el total del producto/día sumando todas sus líneas.
                updateCartUI.setCartItemCount(productId, data.en_carrito);
                updateCartUI.showRemoveItemHome(productId);
                updateCartUI.showToast(data.message);
            }else{
                updateCartUI.showToast(data.message, '#dc3545');
            }
        })
        .catch(error => {
            console.error('Error al agregar el producto al carrito:', error);
            updateCartUI.showToast(mensajeDeError(error, 'No se pudo agregar el producto al carrito'), '#dc3545');
        }).then(function(){
            updateCartUI.toggleButtons(false);
        });
    }

    /**
     * Desde el home (home = true) se borran todas las líneas del producto/día;
     * en el checkout, sólo la línea indicada.
     */
    deleteItem(productId, itemId, home = false) {
        updateCartUI.toggleButtons(true)
        axios.post(route('clientItemDeleteCart'), { item_id: itemId, todo_el_dia: home ? 1 : 0 })
        .then(response => {
            const data = response.data;
            if(!data.status){
                updateCartUI.showToast(data.message, '#dc3545');
                return;
            }
            if(home){
                updateCartUI.setItemHash(productId, data.hash);
                updateCartUI.setCartItemCount(productId, data.en_carrito);
                updateCartUI.updateCartCount(data.cart.items_count);
            }else{
                updateCartUI.removeItem(itemId);
                updateCartUI.refreshState();
            }
            updateCartUI.showToast(data.message);
        })
        .catch(error => {
            console.error('Error al eliminar el producto del carrito:', error);
            updateCartUI.showToast(mensajeDeError(error, 'No se pudo eliminar el producto'), '#dc3545');
        }).then(function(){
            updateCartUI.toggleButtons(false)
        });
    }

    /**
     * "Cambiar" del checkout: quita el plato y lleva al menú (destino), a la
     * sección donde se elige otro. En un combo se quita una unidad, como el
     * "Cambiar" del menú (combo.js); sin combo, la línea entera. Se sale recién
     * cuando el servidor confirmó la baja: si falla, se queda con el error.
     */
    cambiarItem(itemId, cantidad, destino) {
        updateCartUI.toggleButtons(true);
        $('.cart-cambiar').prop('disabled', true);
        let saliendo = false;

        const request = cantidad > 1
            ? axios.post(route('clientUpdateCart'), { item_id: itemId, quantity: cantidad - 1 })
            : axios.post(route('clientItemDeleteCart'), { item_id: itemId, todo_el_dia: 0 });

        request
        .then(response => {
            const data = response.data;
            if(!data.status){
                updateCartUI.showToast(data.message, '#dc3545');
                return;
            }
            saliendo = true;
            window.location.href = destino;
        })
        .catch(error => {
            console.error('Error al cambiar el producto:', error);
            updateCartUI.showToast(mensajeDeError(error, 'No se pudo cambiar el producto'), '#dc3545');
        }).then(function(){
            // Mientras carga el menú, los botones siguen deshabilitados: un segundo
            // click quitaría otro plato.
            if(!saliendo){
                updateCartUI.toggleButtons(false);
                $('.cart-cambiar').prop('disabled', false);
            }
        });
    }

    adjustQuantity(itemId, change) {
        const currentQuantity = parseInt(document.getElementById('count-' + itemId).value);
        const newQuantity = currentQuantity + change;

        if (newQuantity > 0) {
            this.updateCart(itemId, newQuantity);
        }
    }
}

export default new Cart();
